import React from 'react';

import { Link } from 'gatsby';

import { DownChevronSvg, UpChevronSvg } from '../../common/svg';

import '../../../styles/shop/category-filter-list.scss';

const buildLinkPath = (pathStem, slug, sortSlug) => {
  let path = '/shop';
  path += (pathStem && pathStem.length > 0) ? `/${pathStem}/` : '';

  path += slug;

  path += sortSlug ? `/${sortSlug}` : '';

  return path;
}

class CategoryFilterList extends React.Component {
  constructor(props) {
    super(props);

    this.headerRef = React.createRef();

    this.state = {
      expanded: false
    };

    this.toggleExpansion = this.toggleExpansion.bind(this);
  }

  toggleExpansion() {
    if (this.state.expanded) {
      this.headerRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    return (
      <div className="category-filter-list">
        <h4 ref={this.headerRef}>{this.props.listHeader}</h4>
        <div className={`list-container ${this.state.expanded ? 'expanded' : ''}`}>
          <ul>
            {this.props.links.map((link, idx) => (
              <li key={idx}>
                <Link to={ buildLinkPath(this.props.pathStem, link.slug, this.props.sortSlug) }>
                  {link.label} <span className="count">({link.count})</span>
                </Link>
              </li>
            ))}
          </ul>
          <button
            onClick={ () => this.toggleExpansion() }
            className="toggle-link"
          >
            <div className="fuzzy-edge"></div>
            <div className="contents">
              {this.state.expanded ? (
                <>{ UpChevronSvg }</>
              ) : (
                <>{ DownChevronSvg }</>
              )}
            </div>
          </button>
        </div>
      </div>
    );
  }
}

export default CategoryFilterList;
